import { AfterViewInit, Component, DestroyRef, Inject, Input, OnInit, Optional, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MEDIA_TOKEN } from 'tockens';
import { SlideInOutAnimation } from '@app/components/animations/menuanimations';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'clever-menu2-item',
    templateUrl: './menu2-item.component.html',
    styleUrls: ['./menu2-item.component.scss'],
    animations: [SlideInOutAnimation],
    standalone: false
})
export class Menu2ItemComponent implements OnInit, AfterViewInit {
    @Input() menu: any;
    @Input() deskmode: string;

    @ViewChild('mymenudiv') mymenudiv: any;
    @ViewChild('mydropdown') mydropdown: any;

    animationState = 'out';
    innerWidth = 0;

    destroyRef = inject(DestroyRef);
    fromleft = '';
    isBrowser: boolean = false;
    partner: Partner;
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected guardService: AuthGuardService
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.innerWidth = window.innerWidth;
            this.initPartner();
        }
    }

    async initPartner() {
        this.guardService.getPartner$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((obj) => {
                if (obj?.partnerid?.length > 0) {
                    this.partner = obj;
                }
            });
    }

    ngAfterViewInit(): void {
        if (this.isBrowser) {
            setTimeout(() => {
                this.checkfromleft()
            }, 100);
        }
    }


    onResize(event) {
        if (this.isBrowser) {
            this.innerWidth = window.innerWidth;
            setTimeout(() => {
                this.checkfromleft()
            }, 100);
        }
    }

    async checkfromleft() {
        if (this.mymenudiv?.nativeElement && this.mydropdown?.nativeElement) {
            this.fromleft = (this.innerWidth - this.mymenudiv.nativeElement.offsetLeft) < this.mydropdown.nativeElement.offsetWidth
                ? (this.mymenudiv.nativeElement.offsetLeft - (this.mydropdown.nativeElement.offsetWidth - (this.innerWidth - this.mymenudiv.nativeElement.offsetLeft - 77))) + 'px'
                : this.mymenudiv.nativeElement.offsetLeft + 'px';
        }
    }

    toggleShowDiv() {
        this.animationState = 'in';
    }

    toggleHidDiv() {
        this.animationState = 'out';
    }
}
